module.exports = __webpack_public_path__ + "img/QR_02.307831b5.png";